import { SeriesRegistrantList } from '@goldcast/api/backend';
import moment from 'moment';

import { getTimezoneAbbreviationOnDate, guessUserTimezone } from '@/utils/timezone';

export const SERIES_REGISTRANTS_COLUMNS = [
  {
    name: 'Name',
    allowOrdering: true,
    key: 'full_name'
  },
  {
    name: 'Email',
    key: 'email'
  },
  {
    name: 'Company',
    allowFiltering: true,
    key: 'company',
    isFilterOpen: false
  },
  {
    name: 'Title',
    key: 'title'
  },
  {
    name: 'Events',
    allowFiltering: true,
    key: 'events',
    isFilterOpen: false
  }
];

export function transformSeriesRegistrants(seriesRegistrants: SeriesRegistrantList[]) {
  return seriesRegistrants.map(seriesRegistrant => {
    return {
      ...seriesRegistrant,
      selected: false
    };
  });
}

export function getFormattedEventDateFromUTC(date: string): string {
  const userTimezone = guessUserTimezone();

  const timezoneAbbreviation = getTimezoneAbbreviationOnDate(new Date(date), userTimezone);
  const formattedStartDate = moment.tz(date, userTimezone.split(' ')[0]).format('MMM D, YYYY [at] h:mm A');

  return `${formattedStartDate} ${timezoneAbbreviation}`;
}
